//3PL tally runs two ways off the same screens: SLI in, SLO out. The route says which.
export const tallyTransTypeIn = "SLI";
export const tallyTransTypeOut = "SLO";

export const isTallyOutPath = (pathname: string): boolean => {
  return (pathname || "").toLowerCase().includes("tallyout");
};

export const tallyTransTypeFor = (pathname: string): string => {
  return isTallyOutPath(pathname) ? tallyTransTypeOut : tallyTransTypeIn;
};

//route prefix for the current mode, so the screens navigate within their own flow
export const tallyRoutes = (pathname: string) => {
  const out = isTallyOutPath(pathname);
  return {
    list: out ? "/tallyout" : "/tallyin",
    lines: out ? "/tallyoutorder" : "/tallyinorder",
    line: out ? "/tallyoutline" : "/tallyinline",
    title: out ? "3PL Tally Out" : "3PL Tally In",
  };
};
